import React from "react";
import BasePopupResultHistoryClass from "../baseClass";

import { assetImg } from "@/modules/moduleImporter";

import {
	checkBaccaratPairExists,
	renderResultHistory,
	getATValue
} from "@/modules/commonPopupResultHistory";

import "../index.scss";

//Template: m23
//Baccarat
export default class M22 extends BasePopupResultHistoryClass {
	render() {
		const { langdata, orientation } = this.props;
		const imgBackCard = <img src={this.imgBackCard} alt="back card" />;
	
		// PORTRAIT TAB NAMES
		const tabNames = ["Win Cards", "50:50"];
		
		// HEADERS
		const landscapeHeaders = [
			`${langdata["txt_round_id"]}`,
			`${langdata["txt_shoe"]}-${langdata["txt_periode"]}`,
			langdata["txt_win"],
			
			"Player",
			"Banker", //4
			
			"Banker/Player Pair",
			"Either/Perfect Pair",
			"Big-Small"
		];
		
		//Removes 2 last columns for I4S
		if (this.basePcode === "m28")
			landscapeHeaders.splice(-2);

		// TAB HEADER ELEMENTS
		const portraitHeaderIndices = (
			this.props.portraitTabIndex === 0 ? [0, 1, 2, 3, 4] :
			[0, 1, 5, 6, 7]
		);

		// TABLE BODY
		const bodyMapFunction = (item: any, idx: number) => {
			const totalX = (item.banker + item.player).split("x").length - 1;
			
			const bankerAry: string[] = item.banker.split("-");
			const playerAry: string[] = item.player.split("-");
			
			const bankerPair = checkBaccaratPairExists(bankerAry);
			const playerPair = checkBaccaratPairExists(playerAry);
			
			const bankerValue = bankerAry.slice(0).map(_item => getATValue(_item)).reduce((a, b) => a + b) % 10;
			const playerValue = playerAry.slice(0).map(_item => getATValue(_item)).reduce((a, b) => a + b) % 10;
		
			const cells = [
				item.idnomor,
				`${item.gamekey}-${item.periode}`,
				(
					bankerValue > playerValue ? <div className="bg-red">B</div> :
					bankerValue === playerValue ?
						<div className="bg-green">
							T{this.basePcode === "m22" ? bankerValue : ""}
						</div> :
					<div className="bg-blue">P</div>
				),
				
				playerAry.map((_card, _idx) => _card !== "x" ?
					assetImg("baccarat", _card, `pA${_idx}`) :
					imgBackCard),
				bankerAry.map((_card, _idx) => _card !== "x" ?
					assetImg("baccarat", _card, `bA${_idx}`) :
					imgBackCard),

				[
					bankerPair ? <div key="bP" className="bg-red">Pair</div> : "-",
					playerPair ? <div key="pP" className="bg-blue">Pair</div> : "-"
				],
				
				
				`${ bankerPair && playerPair ? langdata["txt_perfect_pair"] :
					bankerPair || playerPair ? langdata["txt_either_pair"] : "-"
					}`,
				
				(6 - totalX > 4 ?
					langdata["txt_big"] :
					langdata["txt_small"])
			];
			
			//Removes 2 last cells for I4S
			if (this.basePcode === "m28")
				cells.splice(-2);

			//Template functions start here
			const landscapeColumns = cells.map((cell, _idx) =>
				<td key={"lC_" + _idx}>
					{cell}
				</td>
			), portraitColumns = portraitHeaderIndices.map((num, _idx) =>
				<td key={"pC_" + this.props.portraitTabIndex + _idx}>
					{ cells[num] }
				</td>
			);
		
			return (
				<tr key={"tpdhm_" + idx}>
					{
						orientation === "landscape" ?
						landscapeColumns : portraitColumns
					}
				</tr>
			);
		};

		// Template Tab Headers, no need to change
		const headers = orientation === "landscape" ?
			landscapeHeaders :
			portraitHeaderIndices.map(num => landscapeHeaders[num]);

		// Template function, no need to change
		return renderResultHistory(
			this.props.activeGame.resultHistory,
			this.basePcode,
			headers,
			bodyMapFunction,
			
			this.props.gameResultHistoryPage,

			this.props.fetchResultHistory,
			this.props.changePortraitResultHistoryTab,
			
			{
				mobile: this.props.mobile,
				mobileHome: this.props.mobileHome,
				desktop: this.props.desktop,
				orientation: orientation,
				tabNames: tabNames,
				
				portraitTabIndex: this.props.portraitTabIndex,
				showGameResultHistoryLoadingOverlay: this.props.showGameResultHistoryLoadingOverlay
			}
		);
	}
}